import { useContext } from "react";
import NodeContext from "../../utils/NodeContext";

export default function SidebarLocation({ isOpen }) {
	const { primaryNode } = useContext(NodeContext);
	return (
		<div className={isOpen ? "block" : "hidden"}>
			{primaryNode.photo ? (
				<img
					className="w-full h-auto"
					src={primaryNode.photo.sizes.large}
					alt={primaryNode.photo.alt}
				/>
			) : null}
			<div className="p-6">
				<span className="text-sm uppercase font-semibold">
					{primaryNode.type}
				</span>
				{primaryNode.name ? (
					<h3 className="text-4xl font-light mb-4">{primaryNode.name}</h3>
				) : null}
				{primaryNode.bio ? (
					<div
						className="space-y-3"
						dangerouslySetInnerHTML={{ __html: primaryNode.bio }}
					/>
				) : null}
				<div className="my-6 py-6 space-x-4">
					<span className="text-sm uppercase font-semibold">
						BRN Connections
					</span>
					<div className="flex items-center space-x-2 mt-6">
						<span className="text-6xl font-bold w-20">
							{primaryNode.researcher_count}
						</span>
						<span className="text-lg font-semibold">Researchers</span>
					</div>
					<div className="flex items-center space-x-2 mt-8">
						<span className="text-6xl font-bold w-20">
							{primaryNode.focus_count}
						</span>
						<span className="text-lg font-semibold">Areas of Focus</span>
					</div>
				</div>
			</div>
		</div>
	);
}
